module.exports = __webpack_public_path__ + "img/makro.2c2caafc.jpg";